import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { routes } from "../constants";
import ExternalLinkButton from "./ExternalLinkButton";
export default function TerminateServiceModal(props) {
  const {
    serviceName,
    agreementId,
    stoppageMayAffectNextBill,
    canPauseService,
    onKeepService,
    onStopService
  } = props;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Stop \u201C".concat(serviceName, "\u201D?"),
    skin: "danger",
    "data-testid": "terminate-service-modal",
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to stop this service?"), /*#__PURE__*/React.createElement(Typography, null, "Your client will no longer be charged for it (we'll let them know)."), stoppageMayAffectNextBill && /*#__PURE__*/React.createElement(Typography, null, "If this service was added to the next bill, it will be removed."), canPauseService && /*#__PURE__*/React.createElement(Typography, {
      style: {
        marginBlockStart: 20
      }
    }, "Note: you may pause the service on the", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: routes.billingHub(agreementId)
    }, "billing hub"), ".")),
    primaryButtonLabel: "Stop service",
    onPrimaryButtonClick: () => onKeepService(),
    secondaryButtonLabel: "Keep service",
    onSecondaryButtonClick: () => onStopService(),
    onCloseButtonClick: () => onStopService()
  });
}